import { useState } from "react"
import { usePost } from "../../api/reactQueryCustomHooks"
import { useNavigate } from "react-router-dom"
import { apiRoute, linksUrl } from "../../constants/enum"
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { MainContainer } from "../../components"
import { Card, CardBody, CardFooter, Button, Input } from "@nextui-org/react"

function AddClientMaster() {
  const navigate = useNavigate()

  const [isVisible, setIsVisible] = useState(false)
  const [base64Image, setBase64Image] = useState("")
  const toggleVisibility = () => setIsVisible(!isVisible)

  const [formData, setFormData] = useState({
    client_code: "",
    client_name: "",
    client_group: "",
    server_name: "",
    client_db: "",
    client_db_uid: "",
    client_db_password: "",
    client_db_confirm_password: "",
  })

  const [errors, setErrors] = useState({})

  const onClickPrevPage = () => {
    navigate(linksUrl.clientMaster.read)
  }

  const onSuccessTasks = () => {
    navigate(linksUrl.clientMaster.read)
  }
  const resetValues = () => { }

  const { isPending, mutate: insertClientMaster } = usePost({
    url: apiRoute.clientMaster.add,
    queryKey: "ClientMaster",
    resetValues,
    successMessage: "",
    onSuccessTasks,
  })

  const handleChange = (e) => {
    const { name, value } = e.target
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }))
  }

  const validateForm = () => {
    const newErrors = {}

    // Validate client_code
    if (formData.client_code.trim() === "") {
      newErrors.client_code = "Client Code is required"
    }

    // Validate client_name
    if (formData.client_name.trim() === "") {
      newErrors.client_name = "Client Name is required"
    }

    // Validate client_group
    if (formData.client_group.trim() === "") {
      newErrors.client_group = "Client Group is required"
    }

    // Validate server_name
    if (formData.server_name.trim() === "") {
      newErrors.server_name = "Server Name is required"
    }

    // Validate client_db
    if (formData.client_db.trim() === "") {
      newErrors.client_db = "Database is required"
    }

    // Validate client_db_uid
    if (formData.client_db_uid.trim() === "") {
      newErrors.client_db_uid = "Database User Id is required"
    }

    // Validate client_db_password
    if (formData.client_db_password.trim() === "") {
      newErrors.client_db_password = "Password is required"
    }

    // Validate client_db_confirm_password
    if (formData.client_db_confirm_password.trim() === "") {
      newErrors.client_db_confirm_password = "Confirm Password is required"
    }

    // Validate client_db_confirm_password
    if (formData.client_db_password !== formData.client_db_confirm_password) {
      newErrors.client_db_confirm_password =
        "Confirm Password needs to be same same Password"
    }

    setErrors(newErrors)

    // Return true if there are no errors
    return Object.keys(newErrors).length === 0
  }

  const handleSubmit = (e) => {
    e.preventDefault()
    console.log(formData)
    if (validateForm()) {
      // Perform form submission logic here
      insertClientMaster({
        data: {
          client_code: formData.client_code,
          client_name: formData.client_name,
          client_group: formData.client_group,
          server_name: formData.server_name,
          client_db: formData.client_db,
          client_db_uid: formData.client_db_uid,
          client_db_password: formData.client_db_password,
          client_db_confirm_password: formData.client_db_confirm_password,
          client_logo:base64Image
        },
      })
    }
  }
  const handleFileUpload = (event) => {
    
    const file = event.target.files[0];
     if (file) {
    const reader = new FileReader();
    reader.onloadend = () => {
      setBase64Image(reader.result); // this includes the prefix
    };
      
      reader.readAsDataURL(file);
    }
  }
  // console.log(base64Image)
  return (
    <div>
      <MainContainer
        pageName="Add Client Master"
        breadcrumbs={["Client Master", "Add"]}
        prevPage={{ show: true, onClick: onClickPrevPage }}
      >
        <Card className="max-w-[600px]" shadow="none" classNames="p-0">
          <form onSubmit={handleSubmit}>
            <CardBody className="p-0">
              <div className="flex flex-col gap-4 mx-2">
                <div className="flex w-full flex-wrap md:flex-nowrap mb-2 md:mb-0 gap-4">
                  <Input
                    type="text"
                    label="Client Code"
                    placeholder=" "
                    labelPlacement="outside"
                    isInvalid={errors?.client_code}
                    errorMessage={errors?.client_code}
                    name="client_code"
                    value={formData.client_code}
                    onChange={handleChange}
                    isDisabled={isPending}
                  />
                  <Input
                    type="text"
                    label="Client Name"
                    placeholder=" "
                    labelPlacement="outside"
                    isInvalid={errors?.client_name}
                    errorMessage={errors?.client_name}
                    name="client_name"
                    value={formData.client_name}
                    onChange={handleChange}
                    isDisabled={isPending}
                  />
                </div>
                <div className="flex w-full flex-wrap md:flex-nowrap mb-2 md:mb-0 gap-4">
                  <Input
                    type="text"
                    label="Client Group"
                    placeholder=" "
                    labelPlacement="outside"
                    isInvalid={errors?.client_group}
                    errorMessage={errors?.client_group}
                    name="client_group"
                    value={formData.client_group}
                    onChange={handleChange}
                    isDisabled={isPending}
                  />
                  <Input
                    type="text"
                    label="Database Server Name"
                    placeholder=" "
                    labelPlacement="outside"
                    isInvalid={errors?.server_name}
                    errorMessage={errors?.server_name}
                    name="server_name"
                    value={formData.server_name}
                    onChange={handleChange}
                    isDisabled={isPending}
                  />
                </div>
                <div className="flex w-full flex-wrap md:flex-nowrap mb-2 md:mb-0 gap-4">
                  <Input
                    type="text"
                    label="Client Database"
                    placeholder=" "
                    labelPlacement="outside"
                    isInvalid={errors?.client_db}
                    errorMessage={errors?.client_db}
                    name="client_db"
                    value={formData.client_db}
                    onChange={handleChange}
                    isDisabled={isPending}
                  />
                  <Input
                    type="text"
                    label="Database User Id"
                    placeholder=" "
                    labelPlacement="outside"
                    isInvalid={errors?.client_db_uid}
                    errorMessage={errors?.client_db_uid}
                    name="client_db_uid"
                    value={formData.client_db_uid}
                    onChange={handleChange}
                    isDisabled={isPending}
                  />
                </div>
                <div className="flex w-full flex-wrap md:flex-nowrap mb-2 md:mb-0 gap-4">
                  <Input
                    label="Database Password"
                    labelPlacement="outside"
                    placeholder="****"
                    name="client_db_password"
                    isInvalid={errors?.client_db_password}
                    errorMessage={errors?.client_db_password}
                    value={formData.client_db_password}
                    onChange={handleChange}
                    isDisabled={isPending}
                    endContent={
                      <button
                        className="focus:outline-none"
                        type="button"
                        onClick={toggleVisibility}
                      >
                        {isVisible ? (
                          <FontAwesomeIcon icon={faEyeSlash} />
                        ) : (
                          <FontAwesomeIcon icon={faEye} />
                        )}
                      </button>
                    }
                    type={isVisible ? "text" : "password"}
                  />
                  <Input
                    label="Database Confirm Password"
                    labelPlacement="outside"
                    placeholder="****"
                    name="client_db_confirm_password"
                    isInvalid={errors?.client_db_confirm_password}
                    errorMessage={errors?.client_db_confirm_password}
                    value={formData.client_db_confirm_password}
                    onChange={handleChange}
                    isDisabled={isPending}
                    endContent={
                      <button
                        className="focus:outline-none"
                        type="button"
                        onClick={toggleVisibility}
                      >
                        {isVisible ? (
                          <FontAwesomeIcon icon={faEyeSlash} />
                        ) : (
                          <FontAwesomeIcon icon={faEye} />
                        )}
                      </button>
                    }
                    type={isVisible ? "text" : "password"}
                  />
                </div>
                <div className="flex w-full flex-wrap md:flex-nowrap mb-2 md:mb-0 gap-4">
                  <Input type="file" color="danger" size="md" variant="flat"
                    classNames={{ label: "text-lg text-slate-700 font-semibold" }}
                    accept=".jpg"  onChange={handleFileUpload} ></Input>
                    { base64Image && base64Image!=""?
                    <img src={base64Image} alt="logo" width="50px" ></img>:"no image"}
                </div>
              </div>
            </CardBody>
            <CardFooter>
              <Button color="primary" type="submit" isLoading={isPending}>
                Add Client Master
              </Button>
            </CardFooter>
          </form>
        </Card>
      </MainContainer>
    </div>
  )
}


export default AddClientMaster
